import { render, staticRenderFns } from "./SkewForm.vue?vue&type=template&id=237b0ce4&scoped=true"
import script from "./SkewForm.vue?vue&type=script&lang=js"
export * from "./SkewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237b0ce4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('237b0ce4')) {
      api.createRecord('237b0ce4', component.options)
    } else {
      api.reload('237b0ce4', component.options)
    }
    module.hot.accept("./SkewForm.vue?vue&type=template&id=237b0ce4&scoped=true", function () {
      api.rerender('237b0ce4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/EditorControl/components/SkewForm.vue"
export default component.exports